import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressType, Country } from 'app/profile/models/masterdata.model';
import { SelectSupplierAddressTypes, SelectCountries, SelectFieldConfiguration, SelectSupplierEntityList, getGeneralSettings, getAvailableConfiguration, SelectSupplierDocumentList, SelectCurrentUser } from 'app/profile/store/app.selector';
import { Store, select } from '@ngrx/store';
import { SupplierProfileState } from 'app/profile/store/app.reducer';
import { GetSupplierAddressContactTypes, GetCountryList, GetFieldConfiguration, GetSupplierProfileCurrentUser, GetSupplierAddressListByCode, GetSupplierDocumentsListByCode } from 'app/profile/store/app.actions';
import { Subscription, combineLatest, forkJoin } from 'rxjs';
import { SupplierDocument, Permission, FieldConfig, SupplierEntityPropertyValues, SupplierDocumentPropertyValues, SupplierAddress, OPERATION } from 'app/profile/models/supplier.model';
import { SupplierAddressPropertyValues } from 'app/profile/models/supplier.model';
import { TslFileDrop, TslDialog } from '@tesla/ng-tds';
import { validateAllFormFields, deepfind, updateValueAndValidity, getNestedNode } from 'app/shared/utils/utils';
import { isNullOrUndefined } from 'util';
import { AddressValidator } from 'app/profile/validators/address.validator';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { AddressSuggestionComponent } from 'app/shared/components/address-suggestion/address-suggestion.component';
import { FileUploadService } from '../../../../../common/services/fileUpload.service';
import { ActivatedRoute } from '@angular/router';
import { ValidatorFn,AbstractControl  } from '@angular/forms';
import { CommonService } from 'app/profile/services/common.service';
import { UserDetails } from 'app/profile/models/user.model';
import { I18nService } from '../../../../../shared/services/i18n.service';
import { US_STATE_LIST } from 'app/shared/constants';

@Component({
    selector: 'address-dialog',
    templateUrl: './address-dialog.component.html',
    styleUrls: ['./address-dialog.component.scss']
})
export class AddressDialogComponent implements OnInit {
    @ViewChild('fileDrop', { static: true }) fileDrop: TslFileDrop;
    settings: GeneralSettings;
    addressForm: FormGroup;
    addressTypes: AddressType[];
    subscription: Subscription = {} as Subscription;
    countries: Country[];
    loadedFiles: SupplierDocument[] = [];
    imagesOnly = false;
    entityMap: SupplierEntityPropertyValues[];
    gridAddressTypes: string[] = [];
    data: SupplierAddressPropertyValues = null;
    oldItem = '';
    oldDocItem = '';
    docsList: SupplierDocumentPropertyValues[];
    isDocumentAdding: boolean = false;
    supplierCode: string;
    userDetails: UserDetails = null;
    USAstate: boolean = false;

    get fileSizeLimitMB() { return this.settings.fileSizeLimitMB * 1000000; }

    get AddressformControls() {
        return {
            purpose: this.addressForm.get('purpose'),
            street1: this.addressForm.get('street1'),
            street2: this.addressForm.get('street2'),
            city: this.addressForm.get('city'),
            state: this.addressForm.get('state'),
            country: this.addressForm.get('country'),
            zipCode: this.addressForm.get('zipCode'),
            comments: this.addressForm.get('comments'),
            documents: this.addressForm.get('documents'),
            attachments: this.addressForm.get('attachments'),
            location: this.addressForm.get('location')
        };
    }

    get documents() {
        return this.addressForm.get('documents') as FormArray;
    }

    constructor(private fb: FormBuilder,
        public dialogRef: MatDialogRef<AddressDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private store: Store<SupplierProfileState>,
        private supplierStateService: SupplierStateService,
        private fileUploadService: FileUploadService,
        private commonService: CommonService,
        private translateService: I18nService,
        private route: ActivatedRoute,
        private dialog: TslDialog) {
        this.subscription = new Subscription();
        this.addressForm = this.fb.group({
            purpose: [null, Validators.required],
            country: ['', Validators.required],
            street1: ['', Validators.required],
            street2: [''],
            city: ['', Validators.required],
            state: ['', Validators.required],
            zipCode: ['', Validators.required],
            comments: [null],
            attachments: [null],
            location: ['']
        }, { validator: AddressValidator });
        this.data = dialogData.dataItem;
        console.log('dialogData',dialogData);
        
        this.supplierCode = dialogData.supplierCode;
        this.oldItem = JSON.stringify(dialogData.dataItem);
    }

    ngOnInit() {
        this.store.select(getGeneralSettings).subscribe(res => this.settings = res);
        this.store.dispatch(new GetSupplierProfileCurrentUser());
        this.store.dispatch(new GetSupplierDocumentsListByCode(this.supplierCode));


        this.store.pipe(select(SelectCurrentUser))
            .subscribe((result) => {
                if (result) {
                    this.userDetails = result;
                }
            });
        this.store.dispatch(new GetCountryList());
        this.store.select(SelectSupplierDocumentList).subscribe(docsList => {
            if (docsList && docsList.length > 0) {
                this.docsList = new Array(...docsList);
            }
        });
        
        if (this.data && this.data.countryCode && this.data.countryCode.newValue == "US") { 
            this.USAstate = true;
        }

        this.store.select(SelectFieldConfiguration).subscribe((addressConfig: FieldConfig[]) => {
            if (addressConfig) {
                if (addressConfig.find(x => x.name == 'Street Address Line 1') && addressConfig.find(x => x.name == 'Street Address Line 1').required == 'Yes')
                    this.addressForm.get('street1').setValidators(Validators.required);
                else
                    this.addressForm.get('street1').clearValidators();
                if (addressConfig.find(x => x.name == 'Street Address Line 2') && addressConfig.find(x => x.name == 'Street Address Line 2').required == 'Yes')
                    this.addressForm.get('street2').setValidators(Validators.required);
                else
                    this.addressForm.get('street2').clearValidators();
                if (addressConfig.find(x => x.name == 'City') && addressConfig.find(x => x.name == 'City').required == 'Yes')
                    this.addressForm.get('city').setValidators(Validators.required);
                else
                    this.addressForm.get('city').clearValidators();
                if (addressConfig.find(x => x.name == 'State') && addressConfig.find(x => x.name == 'State').required == 'Yes')
                    this.addressForm.get('state').setValidators(this.USAstate==true?[Validators.required, this.usStateValiator()]:[Validators.required]);
                else
                    this.addressForm.get('state').clearValidators();
                if (addressConfig.find(x => x.name == 'Zip Code') && addressConfig.find(x => x.name == 'Zip Code').required == 'Yes')
                    this.addressForm.get('zipCode').setValidators(Validators.required);
                else
                    this.addressForm.get('zipCode').clearValidators();
                updateValueAndValidity(this.addressForm);
            }
        });
console.log(this.data);

        if (this.data) {
            this.addressForm = this.fb.group({
                purpose: [{
                    value: this.addressTypes ? this.addressTypes.find(x => this.data.types.newValue.indexOf(x.name) > -1) : this.data.types,
                    disabled: true
                }, Validators.required],
                street1: [{
                    value: this.data.street1.newValue ? this.data.street1.newValue : null,
                    disabled: this.data.street1.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.street1.permission),
                }],
                street2: [{
                    value: this.data.street2.newValue ? this.data.street2.newValue : null,
                    disabled: this.data.street2.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.street2.permission),
                }],
                city: [{
                    value: this.data.city.newValue ? this.data.city.newValue : null,
                    disabled: this.data.city.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.city.permission),
                }],
                state: [{
                    value: this.data.state.newValue ? this.data.state.newValue : null,
                    disabled: this.data.state.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.state.permission),
                }, this.USAstate==true?[Validators.required, this.usStateValiator()]:[Validators.required]],
                country: [{
                    value: this.countries && this.data.countryCode.newValue ?
                        this.countries.find(x => x.abbreviation === this.data.countryCode.newValue) : this.data.countryCode,
                    disabled: this.data.countryCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.countryCode.permission),
                }, Validators.required],
                zipCode: [{
                    value: this.data.zipCode.newValue ? this.data.zipCode.newValue : null,
                    disabled: this.data.zipCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.zipCode.permission),
                }],
                comments: [{
                    value: this.data.comment.newValue ? this.data.comment.newValue : null,
                    disabled: this.data.comment.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.comment.permission)
                }],
                location: [{
                    value: this.data.locationName ? this.data.locationName : null,
                    disabled: null
                }],
                attachments: [{
                    value: this.data.attachments ? this.data.attachments : null,
                    disabled: null
                }]
            }, { validator: AddressValidator });

            // this.onChangePurpose({id: 1, name: "RemitTo", enabled: true});

            if (this.data.documents && this.data.documents.newValue) {
                let addressDocList = this.docsList.filter(x => this.data.documents.newValue.includes(x.documentID.newValue));
                this.addressForm.setControl('documents', this.fb.array(this.getDocumentsGroup(addressDocList)));
                this.oldDocItem = JSON.stringify(this.documents.value);
            }


            if (this.data.types.newValue[0] !== 'Off-Site Part Storage Locations') {
                this.store.dispatch(new GetFieldConfiguration({
                    Section: 'Address',
                    CountryCode: this.data.countryCode.newValue
                }));
            }
        }
        else {
            this.addressForm.get('country').markAsTouched();
        }

        const type = this.store.select(SelectSupplierAddressTypes).subscribe(items => {
            if (items) {
                this.store.select((getAvailableConfiguration)).subscribe((availableFields: string[]) => {

                    console.log('availableFields',availableFields);
                    

                    this.addressTypes = items.filter(x => x.id != 4);

                    if (!availableFields.includes('Add Address - Remit To')) {
                        this.addressTypes = this.addressTypes.filter((x => x.id != 1));
                    }
                    if (!availableFields.includes('Add Address - Manufacturing')) {
                        this.addressTypes = this.addressTypes.filter((x => x.id != 2));
                    }
                    if (!availableFields.includes('Add Non-Tesla Warehouse Address')) {
                        this.addressTypes = this.addressTypes.filter((x => x.id != 3));
                    }
                    if (!availableFields.includes('Add Address - Tesla Shipfrom')) {
                        this.addressTypes = this.addressTypes.filter((x => x.id != 4));
                    }

                    if (this.data) {
                        this.addressForm.patchValue({
                            purpose: this.data.types ? this.addressTypes.find(x => this.data.types.newValue.indexOf(x.name) > -1) : null
                        });
                    }
                    else {
                        // if there is already a manufacturing address
                        if (this.dialogData.alreadyHasManufacturing) {
                            this.addressTypes = this.addressTypes.filter((x => x.id != 2));
                        }

                        if (this.dialogData.hasPendingValidationTask) {
                            this.addressTypes = this.addressTypes.filter((x => x.id != 1));
                        }
                    }

                    // if(this.addressTypes.length > 0) {
                    //     for(let i=0; i<this.addressTypes.length; i++) {
                    //         this.addressTypes[i].name = this.translateService.get(this.addressTypes[i].name)
                    //     }
                    // }
                });
            }
        });

        const country = this.store.pipe(select(SelectCountries)).subscribe(countries => {
            if (countries) {
                this.countries = countries;
                if (this.data) {
                    this.addressForm.patchValue({
                        country: this.data.countryCode ?
                            this.countries.find(x => x.abbreviation === this.data.countryCode.newValue).abbreviation : null
                    }, { onlySelf: true });
                    this.addressForm.updateValueAndValidity();
                }
            }
        });
        
        const addressType = this.addressTypes.find(x=>x.name=== this.dialogData.selectedAddress)
        this.addressForm.controls['purpose'].patchValue(addressType);

        this.addressForm.get('country').valueChanges.subscribe(countryCode => {
            if (countryCode && this.addressForm.get('purpose').value.id !== 3) {
                this.store.dispatch(new GetFieldConfiguration({
                    Section: 'Address',
                    CountryCode: countryCode
                }));
            }
        });


        this.subscription.add(type);
        this.subscription.add(country);
    }

    private getDocumentsGroup(addressDocList: SupplierDocumentPropertyValues[]): FormGroup[] {
        return addressDocList.map(x => {
            return this.getDocumentGroup(x);
        });
    }

    private getDocumentGroup(x: SupplierDocumentPropertyValues): FormGroup {
        return this.fb.group({
            documentId: [x.documentID.newValue, null],
            fileName: [x.fileName.newValue, Validators.required],
            attachment: [null],
            effectiveDate: [x.effectiveDate.newValue, Validators.required],
            expirationDate: [x.expiryDate.newValue, Validators.required],
            signDate: [x.signedDate.newValue, null]
        });
    }

    private onDocumentAdding() {
        this.isDocumentAdding = true;
    }

    onClose(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    onFileAdd(event): void {
        let file = event[0];
        if (file) {
            if (file.size > this.fileSizeLimitMB) {
                this.dialog.alert(this.translateService.get('Alert'), this.translateService.get('File size can not be more than 10MB!'));
            }
            else {
                const attachment = new SupplierDocument();
                const reader = new FileReader();
                reader.readAsDataURL(file);
                let documentGroup = this.getDocumentGroup(new SupplierDocumentPropertyValues());
                documentGroup.patchValue({ attachment: file, fileName: file.name });
                documentGroup.setValidators(Validators.required);
                documentGroup.updateValueAndValidity();
                if (!this.documents) {
                    this.addressForm.setControl('documents', this.fb.array([documentGroup]));
                }
                else {
                    this.documents.push(documentGroup);
                }
            }
        }
        this.isDocumentAdding = false;
    }

    onFileChange(files) {
        if (!files.length) {
            this.loadedFiles = [];
        } else {
            this.loadedFiles = [...this.loadedFiles, ...files];
        }
    }

    removeFile(index) {
        if (this.documents) {
            this.documents.removeAt(index);
        }
    }

    get getAcceptedFormat() {
        return this.imagesOnly ? '.png, .jpeg, .gif, .jpg, .svg' : '*';
    }

    onChangePurpose(event: any) {
        if (!this.data) {
            // on add clear previous form data
            this.resetValues();
        }

        // update location validation 
        if (event.value.id === 3) {
            this.addressForm.get('location').setValidators(Validators.required);
            updateValueAndValidity(this.addressForm);
        } else {
            this.addressForm.get('location').clearValidators();
        }
    }

    save() {
        if (this.addressForm.valid) {
            if (this.addressForm.get('purpose').value.name === 'RemitTo' && (!this.documents || this.documents.length == 0)) {
                this.dialog.alert(this.translateService.get('Alert'), this.translateService.get('Please upload a document!'));
            }
            else {
                const dialogRef = this.dialog.confirm(this.translateService.get('Confirm'), this.translateService.get('Are you sure you want to save your changes?'), this.translateService.get('OK'), this.translateService.get('Cancel'));
                dialogRef.afterClosed().subscribe(x => {
                    if (x) {
                        this.data = this.data ? { ...this.data } : new SupplierAddressPropertyValues();

                        if (!this.addressForm.get('location').pristine) {
                            this.data.locationName = this.addressForm.get('location').value;
                        }
                        if (!this.addressForm.get('street1').pristine) {
                            this.data.street1.newValue = this.addressForm.get('street1').value;
                        }
                        if (!this.addressForm.get('street2').pristine) {
                            this.data.street2.newValue = this.addressForm.get('street2').value;
                        }
                        if (!this.addressForm.get('city').pristine) {
                            this.data.city.newValue = this.addressForm.get('city').value;
                        }
                        if (!this.addressForm.get('state').pristine) {
                            this.data.state.newValue = this.addressForm.get('state').value;
                        }
                        if (!this.addressForm.get('country').pristine) {
                            this.data.countryCode.newValue = this.addressForm.get('country').value;
                        }
                        if (!this.addressForm.get('zipCode').pristine) {
                            this.data.zipCode.newValue = this.addressForm.get('zipCode').value;
                        }
                        //if (!this.addressForm.get('purpose').pristine) {
                            this.data.types.newValue = [(this.addressForm.get('purpose').value as AddressType).name];
                        //}
                        if (!this.addressForm.get('comments').pristine) {
                            this.data.comment.newValue = this.addressForm.get('comments').value;
                        }

                        // this.openAddressSuggestion([this.data, []]);


                        if (this.data.types.newValue[0] === 'RemitTo' && (!this.documents || this.documents.length == 0)) {
                            this.dialog.alert(this.translateService.get('Alert'), this.translateService.get('Please upload a document!'));
                        }
                        else if (this.oldItem === JSON.stringify(this.data) && this.oldDocItem === JSON.stringify(this.documents.value)) {
                            this.dialog.alert(this.translateService.get('Alert'), this.translateService.get('No changes to sumbit.'));
                        }
                        else {
                            let addressDocList = this.docsList.filter(y => this.data.documents.newValue && this.data.documents.newValue.includes(y.documentID.newValue));
                            if (!addressDocList) {
                                addressDocList = [];
                            }
                            let fileUploading$ = this.documents.controls.filter(d => !d.get('documentId').value).map(doc => {
                                let file = doc.get('attachment').value as File;
                                return this.fileUploadService.uploadFileToServer([file], this.supplierCode);

                            });
                            if (fileUploading$ && fileUploading$.length > 0) {
                                forkJoin(fileUploading$)
                                    .subscribe(supplierDocuments => {
                                        if (supplierDocuments) {
                                            let docList = supplierDocuments.map(supplierDocument => {
                                                const document = new SupplierDocumentPropertyValues();
                                                document.operation.newValue = OPERATION.CREATE;
                                                document.documentID.newValue = supplierDocument.documentID;
                                                document.documentType.newValue = 'ADR';
                                                document.fileName.newValue = supplierDocument.fileName;
                                                document.documentVersion.newValue = supplierDocument.documentVersion;
                                                document.referenceSystem.newValue = 'DMS';
                                                return document;
                                            });

                                            let docControls = this.documents.controls.filter(d => !d.get('documentId').value);

                                            this.documents.controls.forEach((doc, index) => {
                                                let documentId = doc.get('documentId').value;
                                                if (documentId) {
                                                    addressDocList[index].expiryDate.newValue = new Date(doc.get('expirationDate').value);
                                                    addressDocList[index].effectiveDate.newValue = new Date(doc.get('effectiveDate').value);
                                                }
                                            });

                                            docControls.forEach((doc, index) => {
                                                docList[index].expiryDate.newValue = new Date(doc.get('expirationDate').value);
                                                docList[index].effectiveDate.newValue = new Date(doc.get('effectiveDate').value);
                                                docList[index].signedDate.newValue = new Date();
                                            });

                                            addressDocList.push(...docList);
                                            this.data.documents.newValue = addressDocList.map(doc => {
                                                return doc.documentID.newValue;
                                            });
                                            if (this.data.countryCode.newValue === 'US') {
                                                this.openAddressSuggestion([this.data, addressDocList]);
                                            } else {
                                                this.dialogRef.close([this.data, addressDocList]);
                                            }

                                        }
                                    });
                            }
                            else {
                                this.documents.controls.forEach((doc, index) => {
                                    addressDocList[index].operation.newValue = OPERATION.UPDATE;
                                    addressDocList[index].expiryDate.newValue = new Date(doc.get('expirationDate').value);
                                    addressDocList[index].effectiveDate.newValue = new Date(doc.get('effectiveDate').value);
                                });

                                if (this.data.countryCode.newValue === 'US') {
                                    this.openAddressSuggestion([this.data, addressDocList]);
                                } else {
                                    this.dialogRef.close([this.data, addressDocList]);
                                }

                            }
                        }
                    }
                });
            }
        } else {
            validateAllFormFields(this.addressForm);
        }
    }

    openAddressSuggestion(addressDocs): void {
        let [newaddress, docList] = addressDocs;
        const address = new SupplierAddress();
        address.Street1 = newaddress.street1.newValue;
        address.City = newaddress.city.newValue;
        address.State = newaddress.state.newValue;
        address.CountryCode = newaddress.countryCode.newValue;
        address.ZipCode = newaddress.zipCode.newValue;
        this.store.dispatch(new IncrementLoaderCount());
        this.supplierStateService.getPredictions(address).subscribe(prediction => {
            this.store.dispatch(new DecrementLoaderCount());
            if (prediction && prediction.length > 0) {
                var completeAddress = address.Street1 + ", " +
                    address.City + ", " +
                    (address.State ? address.State : "") + " " +
                    address.ZipCode + ", " +
                    this.countries.find(x => x.abbreviation === address.CountryCode).name;

                if (prediction.findIndex(r => r === completeAddress) < 0) {
                    const dialogRef = this.dialog.open(AddressSuggestionComponent, {
                        minWidth: '500px',
                        data: prediction
                    });

                    dialogRef.afterClosed().subscribe((selectedAddress: SupplierAddress) => {
                        if (selectedAddress) {
                            newaddress.countryCode.newValue = selectedAddress.CountryCode;
                            newaddress.street1.newValue = selectedAddress.Street1;
                            newaddress.city.newValue = selectedAddress.City;
                            newaddress.state.newValue = selectedAddress.State;
                            newaddress.zipCode.newValue = selectedAddress.ZipCode;
                        }
                        this.dialogRef.close([newaddress, docList]);
                    });
                    // this.dialogRef.close([newaddress, docList]);
                }
                else {
                    this.dialogRef.close([newaddress, docList]);
                }
            } else {
                this.dialogRef.close([newaddress, docList]);
            }
        });
    }

    public resetValidators(form: FormGroup) {
        for (const key in form.controls) {
            form.get(key).clearValidators();
            form.get(key).updateValueAndValidity();
        }
    }

    resetValues() {
        this.addressForm.get('street1').reset();
        this.addressForm.get('street2').reset();
        this.addressForm.get('city').reset();
        this.addressForm.get('state').reset();
        this.addressForm.get('country').reset();
        this.addressForm.get('zipCode').reset();
        this.addressForm.get('comments').reset();
        if (this.documents) {
            this.addressForm.get('documents').reset();
        }
        this.addressForm.get('attachments').reset();
        this.addressForm.get('location').reset();
    }

    getDocument(documentId: string) {
        if (this.docsList && documentId) {
            return this.docsList.find(doc => getNestedNode(['documentID', 'newValue'], doc) === documentId ||
                getNestedNode(['stageID', 'newValue'], doc) === documentId);
        }
    }
    updateStateValidation(event: any){
        if (event.value=='US'){
          this.USAstate=true;
        }
        else if (event.value!='US'){
          this.USAstate=false;
        }
    }
    usStateValiator(): ValidatorFn{
        return (control: AbstractControl): { [key: string]: any } | null => {
          const stateAbbreviations = US_STATE_LIST;
          if (control.value === null || control.value === '') {
            return null;
          } else if (!/^[A-Z]{2}$/.test(control.value)) {
            return { 'invalidFormat': true };
          } else if (!stateAbbreviations.includes(control.value)) {
            return { 'invalidState': true };
          } else {
            return null;
          }
        };
      }
}
